import { render, staticRenderFns } from "./start-modal-order-description.component.vue?vue&type=template&id=658cb242&scoped=true"
import script from "./start-modal-order-description.component.vue?vue&type=script&lang=js"
export * from "./start-modal-order-description.component.vue?vue&type=script&lang=js"
import style0 from "./start-modal-order-description.component.vue?vue&type=style&index=0&id=658cb242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658cb242",
  null
  
)

export default component.exports